/* eslint-disable babel/camelcase */
import { router } from '%app/js/common/services/router';
import { buildSearchString } from '../../services/searchParams';

const SEARCH_ROUTE = 'evp_ticket_frontend.event_search';

function toUrlState(state = {}) {
    return {
        term: state.what,
        where: state.where,
        place_id: state.wherePlaceId,
        category: state.categoryId,
        date_from: state.dateFrom,
        date_to: state.dateTo,
    };
}

export default function buildSearchUrl(state = {}) {
    return `${router.generatePath(SEARCH_ROUTE)}${buildSearchString(toUrlState(state))}`;
}
